import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  icon: '❌',
  text: '<strong>Improvisas</strong> porque el niño cambia cada día'
}, {
  icon: '❌',
  text: '<strong>No sabes cuándo escalar</strong> estímulos'
}, {
  icon: '❌',
  text: '<strong>En consultorio funciona…</strong> en casa no'
}, {
  icon: '❌',
  text: '<strong>En escuela</strong> se desregula diferente'
}, {
  icon: '❌',
  text: '<strong>Planificas horas</strong> y aún así dudas'
}];
export function IdentificationSection() {
  return <section className="bg-brand-mint py-16 px-6" data-id="element-104">
      <div className="max-w-4xl mx-auto" data-id="element-105">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="font-display font-extrabold tracking-[0.18em] uppercase text-brand-green mb-3 text-[20px]" data-id="element-106">
          Este sistema es para ti si...
        </motion.p>
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="font-display font-black md:text-4xl uppercase mb-10 text-brand-ink text-[32px]" data-id="element-107">
          ¿Te Pasa Esto?
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-108">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} whileHover={{
          scale: 1.02,
          boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
          transition: {
            duration: 0.2
          }
        }} className="flex items-start gap-4 bg-white border border-gray-200 rounded px-5 py-4 border-l-4 border-l-brand-red cursor-default" data-id="element-109">
              <motion.span initial={{
            scale: 0
          }} whileInView={{
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.1 + 0.2,
            type: 'spring',
            stiffness: 200
          }} className="text-xl flex-shrink-0 leading-relaxed" data-id="element-110">
                {point.icon}
              </motion.span>
              <p className="text-base font-medium leading-relaxed text-gray-700" dangerouslySetInnerHTML={{
            __html: point.text
          }} data-id="element-111" />
            </motion.div>)}
        </div>

        {/* Closing tension line */}
        <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        y: 0,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }} whileHover={{
        scale: 1.02,
        boxShadow: '0 12px 40px rgba(34, 197, 94, 0.2)',
        transition: {
          duration: 0.3
        }
      }} className="flex items-start gap-4 bg-brand-green/10 border border-gray-200 rounded px-5 py-5 border-l-4 border-l-brand-green mt-4 cursor-default" data-id="element-112">
          <motion.span initial={{
          scale: 0,
          rotate: -180
        }} whileInView={{
          scale: 1,
          rotate: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.7,
          type: 'spring',
          stiffness: 200
        }} className="text-xl flex-shrink-0 leading-relaxed" data-id="element-113">
            ✅
          </motion.span>
          <p className="text-lg font-bold leading-relaxed text-brand-green-dark" data-id="element-114">
            Si marcaste aunque sea uno, este sistema fue diseñado para ti.
          </p>
        </motion.div>
      </div>
    </section>;
}